import { SET_ROUTE } from '../constants/actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const setRoute = (route) => ({
  type: SET_ROUTE,
  route,
});
